// extracted by mini-css-extract-plugin
export default {"container":"Section_container__KZChN"};